import React from 'react';
import { Group } from '@landr/maestro';
import { ModifiersPayload } from 'controllers/SearchController/types';
import { FiltersParams } from 'types/params';
import ActiveFilter from '../components/ActiveFilter';

const getActiveBpm = (
    bpmlowerbound: string | null,
    bpmupperbound: string | null,
    removeFilter: (modifiers: ModifiersPayload[]) => void,
) => {
    if (!bpmlowerbound) {
        return null;
    }

    const isExactValue = bpmlowerbound === bpmupperbound;
    const exact = `${bpmlowerbound} BPM`;
    const range = `${bpmlowerbound} - ${bpmupperbound} BPM`;

    const normalizedFilter = isExactValue ? exact : range;

    return (
        <Group.Item
            key={`filter-${FiltersParams.bpmlowerbound}-${normalizedFilter}`}
        >
            <ActiveFilter
                onClick={() =>
                    removeFilter([
                        [FiltersParams.bpmlowerbound, bpmlowerbound],
                        [FiltersParams.bpmupperbound, bpmupperbound],
                    ])
                }
                filter={normalizedFilter}
            />
        </Group.Item>
    );
};

export default getActiveBpm;
